export enum FILE_UPLOAD_PURPOSE {
  resume = 'resume',
  avatar = 'avatar',
  logo = 'logo',
  upload = 'upload',
}
